import firebase from "firebase/app";
import "firebase/database"; // If using Firebase database
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAizjtnEA9pfk5iKt9L-U9akHgyaM0ldEI",
  authDomain: "notif-hdc.firebaseapp.com",
  projectId: "notif-hdc",
  storageBucket: "notif-hdc.appspot.com",
  messagingSenderId: "759979376519",
  appId: "1:759979376519:web:697ea978d4fcf9f0f75d22",
  measurementId: "G-WF7NGYCS2T",
};

let db_realtime = firebase.initializeApp(firebaseConfig).firestore();

export default db_realtime;
